import firebase from "@firebase/app";
import 'firebase/analytics'

const firebaseConfig = {
    apiKey: "AIzaSyDuqqXL5fNfI0rlTO72PtI0p1MfMMoly5A",
    authDomain: "flatte-5d26a.firebaseapp.com",
    databaseURL: "https://flatte-5d26a.firebaseio.com",
    projectId: "flatte-5d26a",
    storageBucket: "flatte-5d26a.appspot.com",
    messagingSenderId: "842945748846",
    appId: "1:842945748846:web:ab670f8f17ffa85e6f2b7f",
    measurementId: "G-VZWK7F1V3X"
  };
  
  export default {
    init() {
        firebase.initializeApp(firebaseConfig);
        firebase.analytics();
    }
  }
